const Salida = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 36 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.30013 15.4511L31.1554 9.3546C33.8043 8.64911 35.7211 6.69237 35.0156 4.74894C34.35 2.99187 31.7411 2.49936 29.3717 3.31134L21.3317 6.05344C20.786 6.23979 20.4 6.22648 19.761 5.92032L8.63291 0.675732C8.24688 0.489376 7.82093 0.462753 7.4349 0.569242L6.51644 0.862088C6.13041 0.981888 6.01061 1.43447 6.34339 1.79387L13.0256 8.90202L8.77933 10.3529L2.4166 8.09004C2.00396 7.95693 1.65787 8.02349 1.28515 8.36958L0.88582 8.72898C0.579663 9.00851 0.566352 9.38122 0.832575 9.66076L5.49148 14.9053C6.14372 15.6242 7.10213 15.7706 8.30013 15.4511ZM3.32176 24.6358H32.167C32.8858 24.6358 33.4715 24.0501 33.4715 23.3313C33.4715 22.6125 32.8858 22.0268 32.167 22.0268H3.32176C2.61627 22.0268 2.01727 22.6125 2.01727 23.3313C2.01727 24.0501 2.61627 24.6358 3.32176 24.6358Z"
        fill="black"
      />
    </svg>
  );
};
export default Salida;
